/* Auto-generated from SC_ST Habitations_sent to klabs.xlsx */
const HABITATION_METRICS = {
  "state": {
    "blocks": 388,
    "top3_sc_blocks": "KILVELUR (NAGAPATTINAM) 35.5%, THIRUTHURAIPOONDI (TIRUVARUR) 34.0%, PUZHAL (TIRUVALLUR) 33.6%",
    "top3_st_blocks": "KOLLIHILLS (NAMAKKAL) 48.5%, JAWADHU HILLS (TIRUVANNAMALAI) 47.0%, KALRAYAN HILLS (KALLAKURICHI) 43.7%",
    "v40_sc_villages": 7038,
    "v40_st_villages": 645,
    "sc_habitations": 13798,
    "st_habitations": 2175,
    "population": {
      "sc": 9969785,
      "st": 669086,
      "general": 40483475,
      "total": 51122346
    }
  },
  "districts": {
    "ARIYALUR": {
      "blocks": 6,
      "top3_sc_blocks": "SENDURAI 22.6%, JAYAMKONDAM 21.2%, ARIYALUR 20.2%",
      "top3_st_blocks": "JAYAMKONDAM 1.9%, ANDIMADAM 1.7%, T.PALUR 1.6%",
      "v40_sc_villages": 40,
      "v40_st_villages": 6,
      "sc_habitations": 52,
      "st_habitations": 6,
      "population": {
        "sc": 163770,
        "st": 9946,
        "general": 671100,
        "total": 844816
      }
    },
    "CHENGALPATTU": {
      "blocks": 8,
      "top3_sc_blocks": "CHITHAMUR 33.4%, MADURANTAKAM 33.3%, LATHUR 30.9%",
      "top3_st_blocks": "ACHARAPAKKAM 1.8%, KATTANKOLATHUR 1.6%, THIRUKALUKUNDRAM 1.5%",
      "v40_sc_villages": 297,
      "v40_st_villages": 45,
      "sc_habitations": 656,
      "st_habitations": 48,
      "population": {
        "sc": 381110,
        "st": 19256,
        "general": 1127209,
        "total": 1527575
      }
    },
    "COIMBATORE": {
      "blocks": 12,
      "top3_sc_blocks": "ANNUR 21.9%, MADUKKARAI 18.9%, SULTANPET 18.8%",
      "top3_st_blocks": "KARAMADAI 4.5%, ANAIMALAI 4.0%, P.N.PALAYAM 3.2%",
      "v40_sc_villages": 34,
      "v40_st_villages": 7,
      "sc_habitations": 63,
      "st_habitations": 34,
      "population": {
        "sc": 213492,
        "st": 19565,
        "general": 1021359,
        "total": 1254416
      }
    },
    "CUDDALORE": {
      "blocks": 14,
      "top3_sc_blocks": "KEERAPALAYAM 33.0%, NALLUR 31.7%, KATTUMANNAR KOIL 30.9%",
      "top3_st_blocks": "VRIDHACHALAM 0.8%, PARANGIPETTAI 0.7%, KAMMAPURAM 0.6%",
      "v40_sc_villages": 468,
      "v40_st_villages": 8,
      "sc_habitations": 719,
      "st_habitations": 9,
      "population": {
        "sc": 625788,
        "st": 10082,
        "general": 1800133,
        "total": 2436003
      }
    },
    "DHARMAPURI": {
      "blocks": 10,
      "top3_sc_blocks": "HARUR 22.5%, MORAPPUR 21.6%, KADATHUR 21.0%",
      "top3_st_blocks": "PAPPIREDDIPATTI 17.5%, HARUR 7.0%, PENNAGARAM 2.2%",
      "v40_sc_villages": 136,
      "v40_st_villages": 30,
      "sc_habitations": 255,
      "st_habitations": 151,
      "population": {
        "sc": 213538,
        "st": 60609,
        "general": 1290530,
        "total": 1564677
      }
    },
    "DINDIGUL": {
      "blocks": 14,
      "top3_sc_blocks": "PALANI 24.5%, NILAKOTTAI 24.5%, BATLAGUNDU 22.1%",
      "top3_st_blocks": "KODAIKANAL 3.3%, BATLAGUNDU 0.5%, PALANI 0.2%",
      "v40_sc_villages": 173,
      "v40_st_villages": 7,
      "sc_habitations": 429,
      "st_habitations": 12,
      "population": {
        "sc": 334064,
        "st": 4580,
        "general": 1457344,
        "total": 1795988
      }
    },
    "ERODE": {
      "blocks": 14,
      "top3_sc_blocks": "BHAVANISAGAR 19.3%, KODUMUDI 18.4%, NAMBIYUR 17.5%",
      "top3_st_blocks": "TALAVADI 7.2%, SATHYAMANGALAM 6.1%, THOOKANAICKANPALAYAM 2.3%",
      "v40_sc_villages": 176,
      "v40_st_villages": 17,
      "sc_habitations": 519,
      "st_habitations": 55,
      "population": {
        "sc": 216689,
        "st": 19084,
        "general": 1130722,
        "total": 1366495
      }
    },
    "KALLAKURICHI": {
      "blocks": 9,
      "top3_sc_blocks": "THIYAGADURGAM 29.4%, KALLAKURICHI 27.2%, CHINNASALEM 26.8%",
      "top3_st_blocks": "KALRAYAN HILLS 43.7%, SANKARAPURAM 0.8%, TIRUKOILUR 0.2%",
      "v40_sc_villages": 208,
      "v40_st_villages": 16,
      "sc_habitations": 267,
      "st_habitations": 161,
      "population": {
        "sc": 386515,
        "st": 48826,
        "general": 1188804,
        "total": 1624145
      }
    },
    "KANCHEEPURAM": {
      "blocks": 5,
      "top3_sc_blocks": "UTHIRAMERUR 26.5%, SRIPERUMBUDUR 26.2%, WALAJABAD 25.7%",
      "top3_st_blocks": "UTHIRAMERUR 1.6%, KANCHEEPURAM 1.6%, WALAJABAD 0.9%",
      "v40_sc_villages": 246,
      "v40_st_villages": 30,
      "sc_habitations": 459,
      "st_habitations": 33,
      "population": {
        "sc": 243348,
        "st": 10450,
        "general": 734580,
        "total": 988378
      }
    },
    "KANNIYAKUMARI": {
      "blocks": 9,
      "top3_sc_blocks": "THOVALAI 10.5%, AGASTHEESWARAM 7.8%, RAJAKKAMANGALAM 5.2%",
      "top3_st_blocks": "THIRUVATTAR 2.9%, MELPURAM 1.4%, THOVALAI 0.4%",
      "v40_sc_villages": 26,
      "v40_st_villages": 3,
      "sc_habitations": 43,
      "st_habitations": 22,
      "population": {
        "sc": 26546,
        "st": 3893,
        "general": 646441,
        "total": 676880
      }
    },
    "KARUR": {
      "blocks": 8,
      "top3_sc_blocks": "KULITHALAI 21.6%, ARAVAKURICHI 21.3%, K.PARAMATHI 20.9%",
      "top3_st_blocks": "KRISHNARAYAPURAM 0.0%, KADAVUR 0.0%, KARUR 0.0%",
      "v40_sc_villages": 118,
      "v40_st_villages": 0,
      "sc_habitations": 269,
      "st_habitations": 0,
      "population": {
        "sc": 159718,
        "st": 201,
        "general": 668360,
        "total": 828279
      }
    },
    "KRISHNAGIRI": {
      "blocks": 10,
      "top3_sc_blocks": "UTHANGARAI 18.9%, HOSUR 18.4%, MATHUR 13.7%",
      "top3_st_blocks": "KELAMANGALAM 3.3%, THALLY 3.0%, UTHANGARAI 1.4%",
      "v40_sc_villages": 125,
      "v40_st_villages": 18,
      "sc_habitations": 229,
      "st_habitations": 27,
      "population": {
        "sc": 220945,
        "st": 20980,
        "general": 1465743,
        "total": 1707668
      }
    },
    "MADURAI": {
      "blocks": 13,
      "top3_sc_blocks": "SEDAPATTI 22.7%, MADURAI WEST 21.6%, VADIPATTI 21.5%",
      "top3_st_blocks": "ALANGANALLUR 1.2%, VADIPATTI 1.2%, THIRUPPARANKUNDRAM 0.7%",
      "v40_sc_villages": 143,
      "v40_st_villages": 2,
      "sc_habitations": 210,
      "st_habitations": 2,
      "population": {
        "sc": 272494,
        "st": 4896,
        "general": 1300481,
        "total": 1577871
      }
    },
    "MAYILADUTHURAI": {
      "blocks": 5,
      "top3_sc_blocks": "MAYILADUTHURAI 29.0%, SIRKALI 27.5%, KOLLIDAM 27.4%",
      "top3_st_blocks": "KOLLIDAM 0.3%, MAYILADUTHURAI 0.2%, SIRKALI 0.2%",
      "v40_sc_villages": 124,
      "v40_st_villages": 1,
      "sc_habitations": 237,
      "st_habitations": 1,
      "population": {
        "sc": 272582,
        "st": 1375,
        "general": 741788,
        "total": 1015745
      }
    },
    "NAGAPATTINAM": {
      "blocks": 6,
      "top3_sc_blocks": "KILVELUR 35.5%, THIRUMARUGAL 29.8%, NAGAPATTINAM 27.2%",
      "top3_st_blocks": "KILVELUR 0.2%, NAGAPATTINAM 0.2%, THIRUMARUGAL 0.2%",
      "v40_sc_villages": 118,
      "v40_st_villages": 0,
      "sc_habitations": 287,
      "st_habitations": 0,
      "population": {
        "sc": 188294,
        "st": 839,
        "general": 519500,
        "total": 708633
      }
    },
    "NAMAKKAL": {
      "blocks": 15,
      "top3_sc_blocks": "RASIPURAM 23.9%, NAMAKKAL 22.7%, ERUMAPATTY 22.4%",
      "top3_st_blocks": "KOLLIHILLS 48.5%, NAMAGIRIPET 12.2%, SENDAMANGALAM 3.7%",
      "v40_sc_villages": 169,
      "v40_st_villages": 23,
      "sc_habitations": 293,
      "st_habitations": 318,
      "population": {
        "sc": 248100,
        "st": 55417,
        "general": 1087895,
        "total": 1391412
      }
    },
    "PERAMBALUR": {
      "blocks": 4,
      "top3_sc_blocks": "VEPPUR 27.2%, PERAMBALUR 24.5%, VEPPANTHATTAI 23.1%",
      "top3_st_blocks": "VEPPANTHATTAI 0.9%, ALATHUR 0.1%, PERAMBALUR 0.1%",
      "v40_sc_villages": 21,
      "v40_st_villages": 1,
      "sc_habitations": 25,
      "st_habitations": 1,
      "population": {
        "sc": 150504,
        "st": 2136,
        "general": 468017,
        "total": 620657
      }
    },
    "PUDUKKOTTAI": {
      "blocks": 13,
      "top3_sc_blocks": "GANDARVAKOTTAI 22.0%, KARAMBAKKUDI 21.2%, ANNAVASAL 19.1%",
      "top3_st_blocks": "ANNAVASAL 0.2%, VIRALIMALAI 0.1%, ARANTANGI 0.1%",
      "v40_sc_villages": 280,
      "v40_st_villages": 0,
      "sc_habitations": 558,
      "st_habitations": 0,
      "population": {
        "sc": 251552,
        "st": 845,
        "general": 1341111,
        "total": 1593508
      }
    },
    "RAMANATHAPURAM": {
      "blocks": 11,
      "top3_sc_blocks": "BOGALUR 28.9%, PARAMAKUDI 25.2%, MUDUKULATHUR 23.3%",
      "top3_st_blocks": "RAMANATHAPURAM 0.2%, THIRUVADANAI 0.1%, PARAMAKUDI 0.1%",
      "v40_sc_villages": 228,
      "v40_st_villages": 1,
      "sc_habitations": 399,
      "st_habitations": 1,
      "population": {
        "sc": 213583,
        "st": 526,
        "general": 1009270,
        "total": 1223379
      }
    },
    "RANIPET": {
      "blocks": 7,
      "top3_sc_blocks": "KAVERIPAKKAM 25.6%, ARAKONAM 23.2%, NEMILI 22.3%",
      "top3_st_blocks": "ARAKONAM 1.8%, NEMILI 1.0%, KAVERIPAKKAM 1.0%",
      "v40_sc_villages": 245,
      "v40_st_villages": 48,
      "sc_habitations": 473,
      "st_habitations": 50,
      "population": {
        "sc": 209577,
        "st": 8991,
        "general": 808534,
        "total": 1027102
      }
    },
    "SALEM": {
      "blocks": 20,
      "top3_sc_blocks": "THALAIVASAL 23.4%, AYOTHIYAPATTINAM 21.4%, ATTUR 19.6%",
      "top3_st_blocks": "YERCAUD 37.2%, PEDDANAICKENPALAYAM 21.9%, GANGAVALLI 10.7%",
      "v40_sc_villages": 257,
      "v40_st_villages": 41,
      "sc_habitations": 588,
      "st_habitations": 311,
      "population": {
        "sc": 354545,
        "st": 112334,
        "general": 1957105,
        "total": 2423984
      }
    },
    "SIVAGANGAI": {
      "blocks": 12,
      "top3_sc_blocks": "KANNANGUDI 26.9%, MANAMADURAI 20.1%, THIRUPPUVANAM 20.1%",
      "top3_st_blocks": "DEVAKOTTAI 0.2%, THIRUPPUVANAM 0.2%, SAKKOTTAI 0.0%",
      "v40_sc_villages": 182,
      "v40_st_villages": 0,
      "sc_habitations": 342,
      "st_habitations": 0,
      "population": {
        "sc": 188454,
        "st": 518,
        "general": 952610,
        "total": 1141582
      }
    },
    "TENKASI": {
      "blocks": 10,
      "top3_sc_blocks": "SHENCOTTAI 28.1%, KURUVIKULAM 25.7%, VASUDEVANALLUR 25.3%",
      "top3_st_blocks": "SHENCOTTAI 0.6%, SANKARANKOIL 0.1%, KADAYAM 0.1%",
      "v40_sc_villages": 102,
      "v40_st_villages": 0,
      "sc_habitations": 177,
      "st_habitations": 0,
      "population": {
        "sc": 203675,
        "st": 984,
        "general": 875249,
        "total": 1079908
      }
    },
    "THANJAVUR": {
      "blocks": 14,
      "top3_sc_blocks": "THIRUPPANANDAL 28.7%, AMMAPET 27.1%, BUDALUR 22.7%",
      "top3_st_blocks": "THIRUPPANANDAL 0.2%, PERAVURANI 0.2%, KUMBAKONAM 0.1%",
      "v40_sc_villages": 199,
      "v40_st_villages": 0,
      "sc_habitations": 326,
      "st_habitations": 0,
      "population": {
        "sc": 384291,
        "st": 1465,
        "general": 1667809,
        "total": 2053565
      }
    },
    "THE NILGIRIS": {
      "blocks": 4,
      "top3_sc_blocks": "COONOOR 30.5%, UDHAGAI 21.2%, KOTAGIRI 20.6%",
      "top3_st_blocks": "GUDALUR 9.2%, KOTAGIRI 6.8%, UDHAGAI 2.1%",
      "v40_sc_villages": 29,
      "v40_st_villages": 24,
      "sc_habitations": 291,
      "st_habitations": 143,
      "population": {
        "sc": 91421,
        "st": 22767,
        "general": 310337,
        "total": 424525
      }
    },
    "THENI": {
      "blocks": 8,
      "top3_sc_blocks": "THENI 25.4%, CHINNAMANUR 21.3%, ANDIPATTI 21.3%",
      "top3_st_blocks": "BODINAICKANUR 0.8%, K MYLADUMPARAI 0.3%, PERIYAKULAM 0.3%",
      "v40_sc_villages": 45,
      "v40_st_villages": 4,
      "sc_habitations": 89,
      "st_habitations": 6,
      "population": {
        "sc": 143589,
        "st": 1377,
        "general": 575394,
        "total": 720360
      }
    },
    "THOOTHUKKUDI": {
      "blocks": 12,
      "top3_sc_blocks": "OTTAPIDARAM 29.5%, TIRUCHENDUR 25.8%, KAYATHAR 22.4%",
      "top3_st_blocks": "SRIVAIKUNDAM 0.6%, THOOTHUKUDI 0.3%, KOVILPATTI 0.2%",
      "v40_sc_villages": 185,
      "v40_st_villages": 1,
      "sc_habitations": 358,
      "st_habitations": 1,
      "population": {
        "sc": 248752,
        "st": 1921,
        "general": 971273,
        "total": 1221946
      }
    },
    "TIRUCHIRAPPALLI": {
      "blocks": 14,
      "top3_sc_blocks": "ANDHANALLUR 21.1%, LALGUDI 20.8%, MUSIRI 19.1%",
      "top3_st_blocks": "THURAIYUR 4.9%, UPPILIYAPURAM 4.7%, MANIKANDAM 0.4%",
      "v40_sc_villages": 111,
      "v40_st_villages": 6,
      "sc_habitations": 181,
      "st_habitations": 55,
      "population": {
        "sc": 304979,
        "st": 14519,
        "general": 1469519,
        "total": 1789017
      }
    },
    "TIRUNELVELI": {
      "blocks": 9,
      "top3_sc_blocks": "MANUR 21.4%, PALAYAMKOTTAI 20.4%, CHERANMAHADEVI 18.4%",
      "top3_st_blocks": "RADHAPURAM 1.1%, CHERANMAHADEVI 0.7%, PALAYAMKOTTAI 0.4%",
      "v40_sc_villages": 132,
      "v40_st_villages": 0,
      "sc_habitations": 286,
      "st_habitations": 0,
      "population": {
        "sc": 154812,
        "st": 3115,
        "general": 770260,
        "total": 928187
      }
    },
    "TIRUPATHUR": {
      "blocks": 6,
      "top3_sc_blocks": "MADHANUR 25.8%, THIRUPATHUR 18.4%, KANDHILI 14.8%",
      "top3_st_blocks": "THIRUPATHUR 11.1%, ALANGAYAM 2.1%, JOLARPET 2.0%",
      "v40_sc_villages": 151,
      "v40_st_villages": 15,
      "sc_habitations": 335,
      "st_habitations": 69,
      "population": {
        "sc": 169114,
        "st": 35298,
        "general": 811546,
        "total": 1015958
      }
    },
    "TIRUPPUR": {
      "blocks": 13,
      "top3_sc_blocks": "DHARAPURAM 23.2%, KUNDADAM 21.0%, PONGALUR 20.7%",
      "top3_st_blocks": "UDUMALPET 0.6%, TIRUPPUR 0.2%, UTHUKULI 0.1%",
      "v40_sc_villages": 95,
      "v40_st_villages": 2,
      "sc_habitations": 247,
      "st_habitations": 2,
      "population": {
        "sc": 263539,
        "st": 1947,
        "general": 1139466,
        "total": 1404952
      }
    },
    "TIRUVALLUR": {
      "blocks": 14,
      "top3_sc_blocks": "PUZHAL 33.6%, MINJUR 27.7%, TIRUVALLUR 27.6%",
      "top3_st_blocks": "PALLIPET 3.6%, POONDI 3.0%, ELLAPURAM 2.5%",
      "v40_sc_villages": 476,
      "v40_st_villages": 157,
      "sc_habitations": 1188,
      "st_habitations": 182,
      "population": {
        "sc": 504115,
        "st": 37708,
        "general": 1585280,
        "total": 2127103
      }
    },
    "TIRUVANNAMALAI": {
      "blocks": 18,
      "top3_sc_blocks": "CHENGAM 26.0%, PUDUPALAYAM 23.8%, VANDAVASI 23.2%",
      "top3_st_blocks": "JAWADHU HILLS 47.0%, THANDARAMPET 7.2%, KILPENNATHUR 1.9%",
      "v40_sc_villages": 655,
      "v40_st_villages": 69,
      "sc_habitations": 1033,
      "st_habitations": 338,
      "population": {
        "sc": 502404,
        "st": 87096,
        "general": 2039049,
        "total": 2628549
      }
    },
    "TIRUVARUR": {
      "blocks": 10,
      "top3_sc_blocks": "THIRUTHURAIPOONDI 34.0%, KOTTUR 31.8%, VALANGAIMAN 31.2%",
      "top3_st_blocks": "THIRUTHURAIPOONDI 0.2%, NEEDAMANGALAM 0.1%, KOTTUR 0.1%",
      "v40_sc_villages": 207,
      "v40_st_villages": 0,
      "sc_habitations": 433,
      "st_habitations": 0,
      "population": {
        "sc": 388740,
        "st": 939,
        "general": 1006482,
        "total": 1396161
      }
    },
    "VELLORE": {
      "blocks": 7,
      "top3_sc_blocks": "PERNAMBET 27.5%, VELLORE 22.8%, GUDIYATHAM 21.9%",
      "top3_st_blocks": "ANAICUT 6.2%, KATPADI 1.3%, PERNAMBET 1.2%",
      "v40_sc_villages": 204,
      "v40_st_villages": 31,
      "sc_habitations": 472,
      "st_habitations": 104,
      "population": {
        "sc": 226557,
        "st": 20941,
        "general": 862476,
        "total": 1109974
      }
    },
    "VILLUPURAM": {
      "blocks": 13,
      "top3_sc_blocks": "OLAKKUR 28.1%, MAILAM 26.2%, KANDAMANGALAM 26.1%",
      "top3_st_blocks": "GINGEE 2.1%, VALLAM 1.6%, OLAKKUR 1.5%",
      "v40_sc_villages": 435,
      "v40_st_villages": 31,
      "sc_habitations": 640,
      "st_habitations": 32,
      "population": {
        "sc": 532793,
        "st": 22463,
        "general": 1724156,
        "total": 2279412
      }
    },
    "VIRUDHUNAGAR": {
      "blocks": 11,
      "top3_sc_blocks": "WATRAP 27.2%, SRIVILLIPUTHUR 25.7%, SATTUR 22.9%",
      "top3_st_blocks": "WATRAP 0.2%, SRIVILLIPUTHUR 0.1%, RAJAPALAYAM 0.1%",
      "v40_sc_villages": 198,
      "v40_st_villages": 1,
      "sc_habitations": 370,
      "st_habitations": 1,
      "population": {
        "sc": 315796,
        "st": 1197,
        "general": 1286543,
        "total": 1603536
      }
    }
  }
};

export default HABITATION_METRICS;
